import { withStyles } from '@material-ui/core';

import SelectWithFilterInput from './SelecWithFilterInput';
import { styles } from './SelectWithFilterInput.styles';

const SelectWithFilterInputContainer = withStyles(styles)(
  SelectWithFilterInput
);

export default SelectWithFilterInputContainer;
